import * as React from 'react';

type GetRefAttrFromProps<T> = T extends React.RefAttributes<infer V> ? V : never;

interface ViewWrapperState {
  updateKey: number;
}

/**
 * 视图层高阶组件
 *
 * @description 用于视图层组件的重新渲染
 * @param {React.Component} View 视图层组件
 * @returns {React.Component}
 */
class ViewWrapper<P = unknown> extends React.Component<P, ViewWrapperState> {
  static displayName?: string;
  ref: React.RefObject<{ load?: () => void } & GetRefAttrFromProps<P>>;

  constructor(props: P) {
    super(props);
    this.state = {
      updateKey: Date.now(),
    };

    this.ref = React.createRef();
  }

  load = () => {
    if (typeof this.ref?.current?.load === 'function') {
      this.ref?.current?.load?.();
    }
  };

  reRender = () => {
    this.forceUpdate();
  };

  render() {
    return React.cloneElement(this.props.children as React.ReactElement, {
      ...this.props,
      key: this.state.updateKey,
      ref: this.ref,
    });
  }
}

export default ViewWrapper;
